import { render, staticRenderFns } from "./workscore.vue?vue&type=template&id=36cee845&scoped=true"
import script from "./workscore.vue?vue&type=script&lang=js"
export * from "./workscore.vue?vue&type=script&lang=js"
import style0 from "./workscore.vue?vue&type=style&index=0&id=36cee845&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cee845",
  null
  
)

export default component.exports